module.exports = __webpack_public_path__ + "static/user-thumbnail-2-251c6bdbcb8885f657136c7674533e91.png";